import React, { useMemo } from 'react';
import logo from '../assets/images/logo.png';
import './OurZestLoader.css';

function safeAccent() {
  const value = localStorage.getItem('ourzest_theme') || '#6366f1';
  return /^#[0-9a-f]{6}$/i.test(value) ? value : '#6366f1';
}

export default function OurZestLoader({ compact = false, startup = false }) {
  const accent = useMemo(safeAccent, []);
  return (
    <div
      className={`oz-brand-loader ${compact ? 'is-compact' : 'is-page'} ${startup ? 'is-startup' : ''}`}
      style={{ '--oz-loader-accent': accent }}
      role="status"
      aria-live="polite"
    >
      <div className="oz-loader-stage" aria-hidden="true">
        <span className="oz-loader-orbit" />
        <span className="oz-loader-orbit secondary" />
        <div className="oz-loader-logo"><img src={logo} alt="" /></div>
      </div>
    </div>
  );
}
